<template>
    <div class="experience-section mt-3 container py-3">
        <!-- Row containing image and content -->
        <div class="row">
            <!-- Image column (visible only on medium screens and above) -->
            <div class="d-none d-md-block col-md-6">
                <img src="@/assets/hero.png" alt="Team working together" class="w-100" height="">
            </div>

            <!-- Text content column -->
            <div class="col-12 col-md-6">
                <!-- Section title -->
                <p class="c-link text-uppercase">About Experience</p>
                <!-- Section heading -->
                <h2 class="font-weight-bold">Helping You Put Systems in Place That Work</h2>
                <!-- Section description -->
                <p>
                    We provide expert guidance to navigate complex tax regulations with ease, delivering accurate and
                    timely solutions tailored to your needs. Our goal is to build reliable systems that support your
                    business growth and financial peace of mind.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExperienceSection',
};
</script>

<style scoped>
/* Add styles specific to this component */
.experience-section h2 {
    font-size: 2rem;
    color: #333;
}

.experience-section p {
    font-size: 1rem;
    color: #555;
}

.c-link {
    color: #007bff;
    text-transform: uppercase;
    font-weight: bold;
}
</style>
